import { useLang } from "@/context/LanguageContext";
import { useSettings } from "@/context/SettingsContext";
import { useAuth } from "@/context/AuthContext";
import { Link, useLocation } from "react-router-dom";
import { Languages } from "lucide-react";

export default function BrandHeader() {
  const { lang, toggle, t, isRtl } = useLang();
  const { settings, logo } = useSettings();
  const { user } = useAuth();
  const location = useLocation();

  const brand = lang === "ar" ? settings.brand_name_ar : settings.brand_name_en;
  const tagline = lang === "ar" ? settings.tagline_ar : settings.tagline_en;

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#FDFBF7]/80 border-b border-black/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-logo">
          <img
            src={logo || `${process.env.PUBLIC_URL || ""}/zed-logo.png`}
            alt={brand || "ZED"}
            className="w-10 h-10 rounded-full object-cover shrink-0"
          />
          <div className={`flex flex-col ${isRtl ? "items-end" : "items-start"}`}>
            <span className={`${lang === "ar" ? "font-serif-ar" : "font-serif-en"} text-xl font-semibold text-[#0F5F63] leading-none`}>
              {brand || (lang === "ar" ? "زد" : "ZED")}
            </span>
            {tagline && (
              <span className="text-[10px] uppercase tracking-[0.2em] text-[#5C6B6D] mt-1">
                {tagline}
              </span>
            )}
            <span className="text-[9px] tracking-[0.12em] text-[#5C6B6D]/80 mt-1">
              {lang === "ar" ? "إحدى علامات شركة الإزدهار" : "A Brand by Al-Ezdhar"}
            </span>
          </div>
        </Link>

        <div className="flex items-center gap-2">
          {location.pathname !== "/admin" && !user && (
            <Link
              to="/admin"
              data-testid="admin-link"
              className="text-xs uppercase tracking-widest text-[#5C6B6D] hover:text-[#0F5F63] px-3 py-2 transition-colors"
            >
              {t.admin}
            </Link>
          )}
          {user && location.pathname !== "/admin" && (
            <Link
              to="/admin"
              data-testid="admin-link"
              className="text-xs uppercase tracking-widest text-[#0F5F63] hover:text-[#0A4548] px-3 py-2 transition-colors"
            >
              {user.name || t.admin}
            </Link>
          )}
          <button
            onClick={toggle}
            data-testid="lang-toggle-btn"
            className="inline-flex items-center gap-2 rounded-full border border-[#0F5F63]/20 hover:border-[#0F5F63] px-4 py-2 text-xs uppercase tracking-widest text-[#0F5F63] transition-colors"
          >
            <Languages className="w-3.5 h-3.5" />
            {lang === "en" ? "AR" : "EN"}
          </button>
        </div>
      </div>
    </header>
  );
}
